import { DataType } from "components/EffectSearch/EffectSearch";

export const templates: DataType[] = [
  {
    name: "templates",
    items: [
      {
        label: "2PercentTransactionValue",
        code: "0.02*transaction.grossValue",
        codeRegexMatcher: /^0.02*transaction.grossValue$/g,
      },
      {
        label: "3PercentTransactionValueRoundedUp",
        code: "round_up(0.03*transaction.grossValue)",
        codeRegexMatcher: /^round_up\(0.03\*transaction.grossValue\)$/g,
      },
      {
        label: "5PercentValueProductsInCategory",
        code: "0.05*transaction.category('').grossValue",
        codeRegexMatcher:
          /^0.05\*transaction.category\(['"].*?['"]\).grossValue$/g,
        parameter: "('')",
        parameterType: "text",
        dialogTitle: "category",
        dialogDescription: "dialogDescriptionCategory",
      },
      {
        label: "7PercentValueProductsOfBrand",
        code: "0.07*transaction.maker('').grossValue",
        codeRegexMatcher:
          /^0.07\*transaction.maker\(['"].*?['"]\).grossValue$/g,
        parameter: "('')",
        parameterType: "text",
        dialogTitle: "brand",
        dialogDescription: "dialogDescriptionBrand",
      },
      {
        label: "10PercentValueProductsWithSku",
        code: "0.1*transaction.sku('').grossValue",
        codeRegexMatcher: /^0.1\*transaction.sku\(['"].*?['"]\).grossValue$/g,
        parameter: "('')",
        parameterType: "text",
        dialogTitle: "sku",
        dialogDescription: "dialogDescriptionSku",
      },
      {
        label: "15PercentValueExcludeProductsWithSku",
        code: "0.15*(transaction.grossValue-transaction.sku('').grossValue)",
        codeRegexMatcher:
          /^0.15\*\(transaction.grossValue-transaction.sku\(['"].*?['"]\).grossValue\)$/g,
        parameter: "('')",
        parameterType: "text",
        dialogTitle: "sku",
        dialogDescription: "dialogDescriptionSku",
      },
    ],
  },
];
